import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ClientManagement from './components/ClientManagement';
import ReportGenerator from './components/ReportGenerator';
import Sidebar from './components/Sidebar';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    const authStatus = localStorage.getItem('albertarank_auth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      localStorage.setItem('albertarank_auth', 'true');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('albertarank_auth');
    setCurrentView('dashboard');
    setSelectedClient(null);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex">
        <Sidebar 
          currentView={currentView}
          setCurrentView={setCurrentView}
          onLogout={handleLogout}
          selectedClient={selectedClient}
        />
        
        <main className="flex-1 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentView}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
              className="h-full"
            >
              {currentView === 'dashboard' && (
                <Dashboard selectedClient={selectedClient} />
              )}
              {currentView === 'clients' && (
                <ClientManagement 
                  selectedClient={selectedClient}
                  setSelectedClient={setSelectedClient}
                  setCurrentView={setCurrentView}
                />
              )}
              {currentView === 'reports' && (
                <ReportGenerator selectedClient={selectedClient} />
              )}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </Router>
  );
}

export default App;